import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  currentUserGroups: [],
  enterpriseGroups: [],
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
